import {
  required,
  rules,
  badWords,
  notHttpUrl,
  notNumberOnly,
  disallowInsecureCharacters,
} from '@seek/validators-js';
import { useTranslations } from '@vocab/react';

import translations from 'src/App/Components/UserFormProvider/.vocab';
import type {
  AddUserToAccountInput,
  UserPermissionsInput,
} from 'src/graphql/generated';

import { useField } from './UserFormProvider';

export type UserFormValues = AddUserToAccountInput & UserPermissionsInput;

export const useFields = (isAddFlow: boolean, existingUser: boolean) => {
  const { t } = useTranslations(translations);

  const nameValidationEnabled = isAddFlow && !existingUser;

  const firstNameValidationRules = rules.hirerFirstName({
    requiredLabel: t('Given name required label'),
  });

  const lastNameValidationRules = rules.hirerLastName({
    requiredLabel: t('Family name required label'),
  });

  const firstName = useField({
    id: 'firstName',
    enabled: nameValidationEnabled,
    validators: [
      required,
      badWords,
      notHttpUrl,
      notNumberOnly,
      disallowInsecureCharacters,
      ...firstNameValidationRules.validators,
    ],
    validatorProps: firstNameValidationRules.validatorProps,
  });

  const lastName = useField({
    id: 'lastName',
    enabled: nameValidationEnabled,
    validators: [
      required,
      badWords,
      notHttpUrl,
      notNumberOnly,
      disallowInsecureCharacters,
      ...lastNameValidationRules.validators,
    ],
    validatorProps: lastNameValidationRules.validatorProps,
  });

  const role = useField({ id: 'role' });

  const hasAllPositionAccess = useField({ id: 'hasAllPositionAccess' });

  const hasAnalytics = useField({ id: 'hasAnalytics' });

  const hasPremiumTalentSearch = useField({ id: 'hasPremiumTalentSearch' });

  const canCreatePosition = useField({ id: 'canCreatePosition' });

  return {
    firstName,
    lastName,
    role,
    hasAllPositionAccess,
    hasAnalytics,
    hasPremiumTalentSearch,
    canCreatePosition,
  };
};
